<template>
  <v-app>
    <template>
      <v-navigation-drawer
        app
        clipped
        v-model="drawer"
        floating
        v-if="isMobile() && candidato && candidato.nivel > 1"
      >
        <v-list>
          <card-candidato-logado />
          <v-divider></v-divider>
          <opcoes-menu />
        </v-list>
      </v-navigation-drawer>
      <v-app-bar color="green lighten-4" app clipped-left>
        <v-app-bar-nav-icon
          v-if="isMobile() && candidato && candidato.nivel > 1"
          class="green--text text--darken-4"
          @click="drawer = !drawer"
        >
        </v-app-bar-nav-icon>
        <a href="/"
          ><v-avatar tile>
            <v-img
              contain
              :style="styleImg()"
              src="./assets/logo-coasul.png"
            ></v-img>
          </v-avatar>
        </a>
        <v-toolbar-title
          class="font-weight-bold green--text text--darken-4 ml-2"
          >Trabalhe Conosco</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-chip small v-if="isModoDesenvolvimento()" color="warning"
          >Servidor Homologação</v-chip
        >
      </v-app-bar>
    </template>
    <v-main>
      <v-progress-linear indeterminate v-if="loadingApp"></v-progress-linear>
      <v-container :style="estiloContainer()" v-else>
        <v-alert type="info" v-if="candidato">{{
          candidato.msgcandidato
        }}</v-alert>
        <router-view
          v-if="isMobile() || !candidato || candidato.nivel < 2"
        ></router-view>
        <template v-else>
          <v-row>
            <v-col cols="3">
              <card-candidato-logado />
              <opcoes-menu class="mt-3" />
            </v-col>
            <v-col cols="9">
              <router-view></router-view>
            </v-col>
          </v-row>
        </template>
        <v-btn
          elevation="2"
          fab
          bottom
          fixed
          right
          :x-large="!isMobile()"
          color="teal"
          dark
          @click="abrirWhatsapp()"
          ><v-icon>mdi-whatsapp</v-icon></v-btn
        >
      </v-container>
    </v-main>
    <v-footer min-height="160" class="mt-2" color="grey lighten-5">
      <v-row justify="center" align="center">
        <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
          <card-info-coop titulo="Endereço" icone="mdi-map-marker-outline">
            Rua General Osório, 920. <br />
            São João - PR
          </card-info-coop>
        </v-col>
        <v-col
          xl="auto"
          lg="auto"
          md="auto"
          cols="12"
          align-self="center"
          class="d-flex"
        >
          <card-info-coop
            titulo="Telefone"
            icone="mdi-phone-outline"
            class="mr-4"
          >
            (46) 3533-8100
          </card-info-coop>
          <card-info-coop titulo="WhatsApp" icone="mdi-whatsapp">
            (46) 99985-1826
          </card-info-coop>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CardInfoCoop from "./components/home/CardInfoCoop.vue";
import CardCandidatoLogado from "./components/inscricao/menu/CardCandidatoLogado.vue";
import OpcoesMenu from "./components/inscricao/menu/OpcoesMenu.vue";

export default {
  watch: {
    $mq: function (value) {
      this.setarDrawer(value);
    },
  },
  components: {
    CardInfoCoop,
    CardCandidatoLogado,
    OpcoesMenu,
  },

  computed: mapState(["loadingApp", "candidato"]),
  data: () => ({
    drawer: false,
  }),
  methods: {
    ...mapActions(["abrirWhatsapp"]),
    isModoDesenvolvimento() {
      return process.env.NODE_ENV.toLowerCase() == "development";
    },
    isMobile() {
      return this.$mq == "sm";
    },
    classAreas() {
      return this.isMobile() ? "" : "pl-0";
    },
    styleAreas() {
      if (this.isMobile()) return "";
      return {
        "border-radius": "10px !important",
        height: "100%",
      };
    },
    styleImg() {
      if (this.isMobile()) {
        return {
          "max-width": "38px !important",
        };
      }

      return "";
    },
    estiloContainer() {
      var estilo = {};
      estilo["height"] = "100%";
      estilo["max-width"] = "100%";

      if (this.$mq == "xl" || this.$mq == "lg") estilo["max-width"] = "80%";

      return estilo;
    },
    setarDrawer(value) {
      if (value == "lg" || value == "xl") {
        this.drawer = true;
      }
    },
  },
  created() {
    this.setarDrawer(this.$mq);
  },
};
</script>

<style>
.toasted-container .toasted {
  font-family: "Rubik" !important;
}
.v-card__title {
  word-break: normal !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.75rem !important;
}
</style>
